import React, { createContext, useState, useContext, useCallback } from "react";

const ImportFlowContext = createContext();

export const ImportFlowProvider = ({ children }) => {
  const [importData, setImportData] = useState(null);

  const clearImportData = useCallback(() => setImportData(null), []);

  return (
    <ImportFlowContext.Provider value={{ importData, setImportData, clearImportData }}>
      {children}
    </ImportFlowContext.Provider>
  );
};

export const useImportFlow = () => useContext(ImportFlowContext);
